@if (data && showMessage) {
    <div class="message-center-container" [attr.data-testid]="messageCenter" [class]="messsageBackground" role="region" aria-labelledby="message-center-title">
        <div [class]="isFixed() == true ? 'is-fixed' : ''">
            <mat-accordion class="message-center">
                <mat-expansion-panel
                    [expanded]="panelOpenState"
                    (opened)="panelOpenState = true"
                    (closed)="panelOpenState = false"
                    [hideToggle]="!data.message?.length"
                    class="mat-elevation-z0 border"
                    [attr.aria-labelledby]="'message-center-title'"
                >
                    <mat-expansion-panel-header
                        class="message-center__header"
                        [class]="!data.message?.length ? 'disabled' : ''"
                        [attr.data-testid]="messageCenterToggle"
                        [attr.title]="panelOpenState ? 'Luk besked beskrivelse for ' + data.title : 'Åben besked beskrivelse for ' + data.title"
                        role="button"
                        [attr.aria-expanded]="panelOpenState"
                        [attr.aria-controls]="'message-center-content'"
                    >
                        <mat-panel-title class="message-center__top">
                            <div [attr.id]="'message-center-title-' + index">{{ data.title }}</div>
                            <div class="message-center__top-right">
                                <div [class]="listState ? 'date-frame' : ''">
                                    <span class="text-default date" [attr.aria-label]="'Aktiv fra: ' + (data.activeFrom | date: 'dd-MM-yyyy')">
                                        {{ listState ? (data.activeFrom | date: "dd-MM-yyyy") : (data.activeFrom | date: "dd-MM-yyyy kl. HH:mm") }}
                                    </span>
                                </div>
                                @if (listState) {
                                    <span
                                        class="text-default message-center__top-right-status"
                                        [class]="state"
                                        [attr.aria-label]="'Prioritet: ' + getStateText(data.priority)"
                                    >
                                        {{ getStateText(data.priority) }}
                                    </span>
                                }
                            </div>
                        </mat-panel-title>
                        @if (data.message && data.message.length) {
                            <mat-panel-description
                                class="message-center__description"
                                [attr.aria-label]="!panelOpenState ? getDictionaryItem('show') : getDictionaryItem('close')"
                            >
                                {{ !panelOpenState ? getDictionaryItem("show") : getDictionaryItem("close") }}
                            </mat-panel-description>
                        }
                    </mat-expansion-panel-header>
                    @if (sanitizedMessage && sanitizedMessage !== "") {
                        <div
                            id="message-center-content"
                            class="message-center__text"
                            [attr.data-testid]="messageCenterDescription"
                            [innerHTML]="sanitizedMessage"
                            role="document"
                            aria-live="polite"
                        ></div>
                    }
                </mat-expansion-panel>
            </mat-accordion>
            @if (progressCount) {
                <div
                    class="progress-bar"
                    [attr.data-testid]="messageCenterProgress"
                    [style.animation-duration]="progressCount + 'ms'"
                    role="progressbar"
                    [attr.aria-valuemin]="0"
                    [attr.aria-valuemax]="100"
                    [attr.aria-valuenow]="progressCount"
                    aria-label="Besked fremskridt"
                ></div>
            }
        </div>
    </div>
}
